<template>
    <div class="container-div text-xs-left">
        <div class="container-div" >
            <x-badge color="secondary" overlap :class="{'shake animated': newTasksReceived}" v-click-outside="close">
                <template v-slot:badge>
                    <span>{{formatMyTasksCount()}}</span>
                </template>
                <x-btn @click="openClose()" icon fab color="white">
                    <x-icon>notifications</x-icon>
                </x-btn>
            </x-badge>
        </div>

        <x-card v-show="isOpen" class="my-tasks-list-container">
            <div class="tasks-title">Tasks</div>
            <div>
                <x-data-table
                    class="fit-to-width no-row-hover"
                    :headers="tableHeaders"
                    :items="tasks"
                    hide-actions
                >
                    <template slot="no-data">
                        <h5 class="error-message text-xs-center" v-if="!tableLoading">{{ noResultsMessage }}</h5>
                        <loader />
                    </template>
                    <template slot="items" slot-scope="props" v-if="$root.userCan('view tasks')">
                        <tr>
                            <td>{{props.item.name}}</td>
                            <td>
                                {{formatDate(props.item.due_by)}}
                                <i v-if="isOverdue(props.item.due_by)" class="warning color-overdue"/>
                            </td>
                            <td>
                                <router-link
                                    :to="{ name: 'tasks-view', params: { id: props.item.id } }"
                                >
                                    <i class="arrow_right"/>
                                </router-link>
                            </td>
                        </tr>
                    </template>
                </x-data-table>
            </div>
        </x-card>
    </div>
</template>

<script>
import Loader from '~/components/Shared/UIComponents/Loader'
import ClickOutside from 'vue-click-outside'

export default {
    name: "MyTasksIcon",
    components: {
        Loader
    },
    directives: {
        ClickOutside
    },
    data() {
        return {
            taskCountRefreshRate: 60, //in seconds
            maskTasksCountIfMoreThan: 99,
            myTasksCount: '-',
            myTasksIds: [],
            newTasksReceived: false,
            isOpen: false,
            interval: null,
            tableLoading: true,
            tableHeaders: [
                {
                    text: 'Name',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Due by',
                    value: 'due_by',
                    sortable: true
                },
            ],
            tasks: []
        };
    },
    computed: {
        noResultsMessage() {
            return `Sorry, there are no results.`;
        }
    },
    methods: {
        isOverdue(date) {
            return this.$moment(date).isBefore(new Date())
        },
        formatMyTasksCount() {
            return this.myTasksCount > this.maskTasksCountIfMoreThan ? this.maskTasksCountIfMoreThan + '+' : this.myTasksCount;
        },
        openClose() {
            if (this.hasTasks()) {
                this.isOpen = !this.isOpen;
                if (this.isOpen) {
                    this.tableLoading = true;
                    this.tasks = [];
                    this.getTasksList();
                }
            }
        },
        hasTasks() {
            return this.myTasksIds.length > 0;
        },
        getTasksList() {
            axios.get(this.$root.api('tasks/list/my-tasks')).then(response => {
                this.tasks = response.data.data;
                this.tableLoading = false;
            });
        },
        close() {
            this.isOpen = false;
        },
        // eslint-disable-next-line require-await
        async reloadTasksCount() {
            this.newTasksReceived = false;

            axios.get(this.$root.api('tasks/count/my-tasks')).then(response => {
                this.myTasksCount = response.data.myTasksCount;

                if (this.myTasksIds.length > 0) {
                    response.data.myTasksIds.forEach(id => {
                        if (!this.myTasksIds.includes(id)) {
                            this.newTasksReceived = true;
                            //if list is already open and we've detected new tasks refresh the list
                            if (this.isOpen) {
                                this.getTasksList();
                            }
                        }
                    });
                }

                this.myTasksIds = response.data.myTasksIds;
            });
        },
        formatDate(date) {
            return date ? this.$moment(date).format('D MMM YYYY') : '-';
        },
    },
    mounted() {
        this.popupItem = this.$el;
        this.reloadTasksCount();

        const socket = io.connect(window.location.host, {transports: ['websocket']});

        socket.on("connect_error", (err) => {
            console.log(`connect_error due to ${err.message} on my task icon component`);
        });
        socket.on(`private-task-notification-${this.$root.user.party.id}`, function () {
            this.reloadTasksCount();
        }.bind(this));
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
}
</script>

<style lang="scss" scoped>
    .container-div {
        position: relative;
    }
    .icon-container{
        display: inline-block;
    }
    .clickable{
        cursor: pointer;
    }
    .my-tasks-icon{
        color: $color-white;
        font-size: 2em;
    }
    .indicator-circle{
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -13px;
        top: -13px;
        border-radius: 50%;
        background-color: $color-blue;
        color: $color-white;
        min-width: 30px;
        min-height: 30px;
    }
    .tasks-title{
        font-weight: bold;
        margin-bottom: 2em;
    }
    .my-tasks-list-container{
        position: absolute;
        background-color: $color-white;
        text-align: left;
        padding: 18px;
        width: 26em;
        max-height: 23em;
        overflow: auto;
        margin-top: 1.2em;
        margin-left: -23em;
        z-index: 100;
    }
    .no-select {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .color-overdue{
        color: $color-overdue;
    }

    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .shake {
        -webkit-animation-name: shake;
        animation-name: shake;
    }
</style>
